import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export const DetailsValueBlock = (props: any) => {
    const IconComp = props.icon;

    return <Grid item>
        <Grid container alignItems="flex-start" direction="row">
            <Typography paragraph><strong>{props.title}</strong></Typography>
            {IconComp}
        </Grid>
        <Grid container>
            <Grid item style={{ wordWrap: "break-word", wordBreak: "break-all" }}>
                {props.children}
            </Grid>
        </Grid>
    </Grid>
}

interface ButtonProps {
    title: string;
    actions: any;
}

export const DetailsValueBlockWithButtons: React.SFC<ButtonProps> = (props) => {

    const Actions = props.actions

    return <Grid item>
        <Grid container alignItems="center" justify="space-between" direction="row" spacing={8}>
            <Grid item><Typography><strong>{props.title}</strong></Typography></Grid>
            <Grid item>{Actions}</Grid>
        </Grid>
        <Grid container>
            <Grid item>
                {props.children}
            </Grid>
        </Grid>
    </Grid>
}


// WEBPACK FOOTER //
// ./src/components/tables/DetailsValueBlock.tsx